export default __webpack_public_path__ + "static/media/account.7c190558.png";